import type { ServiceForgotPasswordResult, TranslationPort } from '../../types';
import type { IdentityProvider } from '../identity-provider';
import { AUTH_LOCALE_KEYS } from '../../i18n-keys';

export async function cognitoChangePassword(
  idp: IdentityProvider,
  currentPassword: string,
  newPassword: string,
  t: TranslationPort['t'],
): Promise<ServiceForgotPasswordResult> {
  try {
    await idp.updatePassword(currentPassword, newPassword);
    return { success: t(AUTH_LOCALE_KEYS.PASSWORD_CHANGED_SUCCESS) };
  } catch {
    return { error: t(AUTH_LOCALE_KEYS.INVALID_PASSWORD) };
  }
}

export async function cognitoForgotPassword(
  idp: IdentityProvider,
  email: string,
  t: (key: string, opts?: { defaultValue: string }) => string,
): Promise<ServiceForgotPasswordResult> {
  try {
    await idp.resetPassword(email);
    return { success: t(AUTH_LOCALE_KEYS.PASSWORD_RESET_EMAIL_SENT), nextStep: 'confirm_in_app' };
  } catch {
    return { error: t(AUTH_LOCALE_KEYS.INVALID_EMAIL) };
  }
}

export async function cognitoConfirmForgotPassword(
  idp: IdentityProvider,
  email: string,
  code: string,
  newPassword: string,
  t: (key: string, opts?: { defaultValue: string }) => string,
): Promise<ServiceForgotPasswordResult> {
  try {
    await idp.confirmResetPassword(email, code, newPassword);
    return { success: t(AUTH_LOCALE_KEYS.PASSWORD_CHANGED_SUCCESS) };
  } catch {
    return { error: t(AUTH_LOCALE_KEYS.RESET_TOKEN_INVALID) };
  }
}
